enum EndorsementSectionName {
	LANDING = 'Landing',
	COVERAGES_VIEW = 'CoveragesView',
	INSURED_VIEW = 'InsuredView',
	MORTGAGEES_VIEW = 'MortgageesView',
	PROPERTY_ADDRESS = 'PropertyAddress',
	DWELLING = 'Dwelling',
	LIMITS = 'Limits',
	PERILS_AND_DEDUCTIBLES = 'PerilsAndDeductibles',
	BUILDING = 'Building',
	ADD_BUILDING = 'AddBuilding',
	INSURED = 'Insured',
	MORTGAGEE = 'Mortgagee',
	ADD_MORTGAGEE = 'AddMortgagee',
	REVIEW = 'Review',
	UNKNOWN = 'Unknown',
}

namespace EndorsementSectionName {
	export function toEnumList(): EndorsementSectionName[] {
		let endorsementSectionNames: EndorsementSectionName[] = Object.keys(EndorsementSectionName)
			.filter((key: string) => key !== EndorsementSectionName.toEnumList.name)
			.map((key: string) => EndorsementSectionName[key]);
		return endorsementSectionNames;
	}
}

export default EndorsementSectionName;